import Search from './Search';
import './index.scss';

export { Search };
